import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { ConversionEditorStore } from 'widgets/ConversionEditor'
import styles from 'widgets/ConversionEditor/ui/styles.module.scss'

type IConversionEditorActionsProps = {
  store: ConversionEditorStore
}

export const ConversionEditorActions = observer(({ store }: IConversionEditorActionsProps) => {
  const { isEditMode, onClose, onUpdate, onCreate, onClearConversionData, isSaving, isClearing } =
    store
  const isActionsDisabled = isSaving || isClearing

  return (
    <>
      {isEditMode && (
        <Button
          text={'Clear conversion data'}
          typeBtn={'contained'}
          contained={'secondary'}
          size={'medium'}
          loading={isClearing}
          disabled={isActionsDisabled}
          onClick={onClearConversionData}
        />
      )}
      <Button
        text={'Cancel'}
        typeBtn={'contained'}
        contained={'secondary'}
        disabled={isActionsDisabled}
        onClick={onClose}
        className={styles.cancelButton}
      />
      <Button
        text={isEditMode ? 'Save' : 'Create'}
        typeBtn={'contained'}
        size={'medium'}
        loading={isSaving}
        disabled={isActionsDisabled}
        onClick={isEditMode ? onUpdate : onCreate}
      />
    </>
  )
})
